import TemplateEdit from '../../../../../../components/lane/TemplateEdit';

export default TemplateEdit;
